import { GET_CLIENT_NAME } from './mutation-types'
import loginHttpService from '../_service/LoginHttpService'

export default {
  obterNomeDoCliente: async ({ commit }) => {
    try {
      const response = await loginHttpService.getClientName()
      commit(GET_CLIENT_NAME, response.data)
    } catch (e) {
      console.log(e)
    }
  },

  injetarNomeDoCliente: ({ commit }, clientName) => {
    commit(GET_CLIENT_NAME, clientName)
  },
}
